module.exports = __webpack_public_path__ + "img/nftplay-shape-5.777e16de.png";